/*
 * @Description: 计算字段相关数据存储
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { defineStore } from 'pinia';

const useSettingStore = defineStore('setting', {
  state: () => {
    return {
      conditions: {
        //是以计算字段的fieldKey为键的对象
      },
      setSubNum: 0, //统计子表单的数据
      fieldExt: null
    };
  },
  actions: {
    updateState(params, fieldKey) {
      this.conditions[fieldKey] = params;
    },
    setFieldId(id, fieldKey) {
      if (!this.conditions?.[fieldKey]) {
        this.conditions[fieldKey] = {
          settingId: ''
        };
      }
      this.conditions[fieldKey].settingId = id;
    },
    setFieldExt(objExt) {
      this.fieldExt = objExt;
    },
    clearFieldExt() {
      this.fieldExt = null;
    },
    clearFieldConditions(fieldKey) {
      this.conditions[fieldKey] = {};
    },
    clearAll() {
      this.conditions = {};
      this.fieldExt = null;
    },
    updateSubNum(num) {
      this.setSubNum = num;
    }
  }
});

export default useSettingStore;
